import { api } from '@/services';
import type { SelecionarNfsePdfResponse } from '../types';

export async function fetchSelecionarNfsePdf(
  chaveAcessoDoc: string
): Promise<SelecionarNfsePdfResponse> {
  return api.get(`Documento/Select/NFS/${encodeURIComponent(chaveAcessoDoc)}`);
}
